import { Route } from "@angular/router";
import { EditarEnderecoPage } from "./editar-endereco.page";

export const EditarEnderecoRouter: Route[] = [
  { path: 'editar-endereco', component: EditarEnderecoPage }
];
